import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import useGetFiscalYearList from 'hooks/consume_api/query/useGetFiscalYearList';
import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import BadcDetailsByFiscalYear from './BadcDetailsByFiscalYear';
import Badc from './Badc';
import BadcDetailsEdit from './BadcDetailsEdit';

const BadcMain: React.FC = () => {
    const { data, isFetching } = useGetFiscalYearList('1');

    const [viewModal, setViewModal] = useState<boolean>(false);
    const [createModal, setCreateModal] = useState<boolean>(false);
    const [editModal, setEditModal] = useState<boolean>(false);
    const [startYear, setStartYear] = useState<string>('');
    const [endYear, setEndYear] = useState<string>('');

    const handleViewModalOpen = () => setViewModal(true);
    const handleViewModalClose = () => setViewModal(false);

    const handleCreateModalOpen = () => setCreateModal(true);
    const handleCreateModalClose = () => setCreateModal(false);

    const handleEditModalOpen = () => setEditModal(true);
    const handleEditModalClose = () => setEditModal(false);

    const handleView = (startYear: string, endYear: string) => {
        setStartYear(startYear);
        setEndYear(endYear);
        handleViewModalOpen();
    };

    const handleEdit = (startYear: string, endYear: string) => {
        setStartYear(startYear);
        setEndYear(endYear);
        handleEditModalOpen();
    };

    interface fiscalYearType {
        id: number;
        agency: string;
        startYear: string;
        endYear: string;
    }

    return (
        <>
            {data?.data.length === 0 && (
                <Button variant="contained" sx={{ marginBottom: '20px' }} onClick={() => handleCreateModalOpen()}>
                    Add Data
                </Button>
            )}
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">SL</TableCell>
                            <TableCell align="left">Fiscal Year</TableCell>
                            <TableCell align="left">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.data.map((item: fiscalYearType, index: number) => (
                            <TableRow key={item.id}>
                                <TableCell align="left">{index + 1}</TableCell>
                                <TableCell align="left">
                                    {item.startYear}-{item.endYear}
                                </TableCell>
                                <TableCell align="left">
                                    <VisibilityIcon
                                        onClick={() => handleView(item.startYear, item.endYear)}
                                        sx={{ cursor: 'pointer' }}
                                    />
                                    <EditIcon onClick={() => handleEdit(item.startYear, item.endYear)} sx={{ cursor: 'pointer' }} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {viewModal && (
                <BadcDetailsByFiscalYear
                    open={viewModal}
                    handleClose={handleViewModalClose}
                    agency="1"
                    startYear={startYear}
                    endYear={endYear}
                />
            )}
            {editModal && (
                <BadcDetailsEdit open={editModal} handleClose={handleEditModalClose} agency="1" startYear={startYear} endYear={endYear} />
            )}
            <Badc pOpen={createModal} pHandleClose={handleCreateModalClose} />
        </>
    );
};

export default BadcMain;
